export default
  {
    "header": {
      "title": "FindSampo",
      "login": "Log In",
      "logout": "Log Out",
      "notification": {
        "logoutSuccess": "You have successfully logged out!"
      }
    },
    "": "",
    "loginPage": {
      "title": "Log In",
      "email": "Email",
      "password": "Password",
      "login": "Log In",
      "signup": "Sign up",
      "forgotPassword": "Forgotten your password?",
      "loginWith": "Log in with",
      "googleLogin": "Log in with Google",
      "notAMemberYet": "Not registered yet?",
      "error": {
        "emptyField": "Email and password are needed!"
      }
    },
    "signupPage": {
      "title": "Sign Up",
      "username": "Username",
      "email": "Email",
      "password": "Password",
      "signup": "Sign Up",
      "alreadyAMember": "Already registered",
      "login": "Log In",
      "registrationDone": "Registration successfully completed!"
    },
    "nearByPage": {
      "map": {
        "mapLayers": {
          "backGroundMap": "Background Map",
          "topographicalMap": "Topographic Map",
          "googleMaps": "Google Maps"
        },
        "overLays": {
          "arkeologiset_loydot": "Archaeological finds",
          "arkeologiset_kohteet_alue": "Archaeological Heritage, areas around protected sites and other significant remains",
          "arkeologiset_kohteet_piste": "Archaeological Heritage, protected sites and other significant remains",
          "maailmanperinto_alue": "World Heritage areas",
          "maailmanperinto_piste": "World Heritage sites",
          "rakennusperinto_alue": "Built Heritage, areas around protected buildings",
          "rakennusperinto_piste": "Built Heritage, protected buildings",
          "arkeologisten_kohteiden_alakohteet_piste": "Archaeological heritage, subsites of protected sites and other significant remains",
          "rky_alue": "Nationally significant built cultural environments (RKY), areas",
          "rky_piste": "Nationally significant built cultural environments (RKY), pointlike sites",
          "rky_viiva": "Nationally significant built cultural environments (RKY), roads and other linelike sites"
        },
        "alert": {
          "zoomAlertTitle": "Zoom Level Alert",
          "zoomAlertContent": "Please change the zoom level to 13 to view selected layer.",
          "zoomAlertConfirmation": "OK",
          "gettingLocationFailed": "Unable to retrieve your location. Please make sure that GPS is turned on."
        },
        "mapContent": {
          "name": "Name",
          "town": "Town",
          "link": "Link",
          "more": "More"
        }
      },
      "tabs": {
        "map": "Map",
        "heatmap": "HeatMap",
        "statistics": "Statistics",
        "table": "Table"
      },
      "statistics": {
        "chart": {
          "selectProperty": "Select Property",
          "material": "Material",
          "type": "Object type",
          "period": "Period"
        }
      },
      "table": {
        "title": "Object classification",
        "material": "Material",
        "type": "Object type",
        "period": "Period",
        "municipality": "Municipality",
        "province": "County",
        "specification": "Circumstances of the find",
        "previewImage": "Preview Image",
        "notProvidedValue": "Not provided",
        "noAdditionalInformation": "No additional information found!",
        "more": "More"
      }
    },
    "myFindsPage": {
      "header": {
        "title": "My Finds",
        "show": "Show",
        "orderSelect": {
          "orderBy": "Order By",
          "date": "Date",
          "municipality": "Municipality",
          "totalFinds": "Total Finds"
        }
      },
      "more": "View More",
      "share": "Share",
      "continue": "Continue",
      "status": "Status",
      "noFindsInfo": "The selected report does not have any finds.",
      "noFindsError": "No finds!",
      "container": {
        "report": "Report",
        "municipality": "Municipality",
        "time": "on {d, date, short}",
        "timeClock": "Time",
        "finds": "Number of finds: (number)"
      },
      "statuses": {
        "draft": "Draft",
        "await_review": "Awaiting Review",
        "in_review": "In Review",
        "validated": "Validated",
        "rejected": "Rejected",
        "peding_user": "Pending additional information"
      }
    },
    "notFoundPage": {
      "pageNotFound": "Ooops! Page Not Found!",
      "goToHomePage": "Go To HomePage"
    },
    "legalityCheckerPage": {
      "alert": {
        "allowed": {
          "header": "?There are no restrictions in this location?",
          "description": "We could not find any archaeological heritage site at your location."
        },
        "forbidden": {
          "header": "You are not allowed to dig in this area!",
          "description": "You cannot dig the soil in places protected by the Antiquities Act (295/1963), sites suspected to be ancient monuments, or areas protected under the Nature Conservation Act without a separate permit. Digging nearby a protected ancient monument, at a distance of less than 200 metres from the site, is strongly discouraged."
        }
      }
    },
    "overview": {
      "title": "Summary",
      "notProvidedValue": "Not Provided",
      "findSite": {
        "title": "Find Site Details",
        "photos": "Find Site Photos",
        "location": "Location",
        "additionalMaterials": "Additional information"
      },
      "find": {
        "title": "Find details",
        "subTitle": "Find object",
        "photos": "Photos",
        "depth": "Depth",
        "type": "Object name",
        "timing": "Period",
        "material": "Material"
      }
    },
    "report": {
      "stepOne": "Help",
      "stepTwo": "Details",
      "stepThree": "Additionals",
      "stepFour": "Done!",
      "skip": "Skip",
      "optionalSection": "Optional",
      "reportSent": "Your report has been sent successfully!",
      "back": "Back",
      "notifications": {
        "photoDeletionError": "Deleting the photo failed. Please try again"
      },
      "questionZero": {
        "question": "Would you like to get familiar with our starter kits before starting to report your find?",
        "help": "These questions are for providing some help. Please select one of the choices.",
        "buttonOne": "Yes, please!",
        "buttonTwo": "No, thanks!"
      },
      "questionProvideHelp": {
        "question": "Great, below you can find the most relevant instructions.",
        "help": "Please select one of the guides!",
        "buttonOne": "Continue",
        "options": {
          "optionOne": "General Instructions",
          "optionTwo": "Starter Kit",
          "optionThree": "Reporting Instructions"
        }
      },
      "questionFindTimeDetermining": {
        "question": "Are you reporting a find that has recently been found?",
        "help": "This question is asked to get your current location and date.",
        "buttonOne": "Yes, I am on the find site.",
        "buttonTwo": "No, I found it a while ago."
      },
      "questionFindLocation": {
        "question": "Pick the find location please.",
        "help": "Mark exactly where the find has been found.",
        "buttonOne": "Done, continue"
      },
      "questionFindPhotos": {
        "question": "Please add photos of the find.",
        "help": "At least one photo is needed.",
        "buttonOne": "Continue"
      },
      "questionFindSitePhotos": {
        "question": "Please add some photos from the find site.",
        "help": "At least one photo is needed.",
        "buttonOne": "Continue"
      },
      "questionFindDate": {
        "question": "Please pick OR give an approximate of the find date.",
        "help": "Select the exact date that find has been found.",
        "buttonOne": "Continue",
        "selectionText": "I know the exact date."
      },
      "questionFindDepth": {
        "question": "Please input the find depth.",
        "help": "Add some explanation of the find depth.",
        "label": "Find Depth",
        "depth": "Depth",
        "buttonOne": "Continue",
        "useSlider": "Use the slider",
        "depthUnit": "cm"
      },
      "questionFindMaterial": {
        "question": "Select the material of the find.",
        "help": "If you cannot find the material you can select 'others' option.",
        "buttonOne": "Continue",
        "label": "Material",
        "placeholder": "e.g. stone, gold, bronze"
      },
      "questionFindType": {
        "question": "Select the name of the object.",
        "help": "If you cannot find the type you can select 'others' option.",
        "buttonOne": "Continue",
        "label": "Type",
        "placeholder": "e.g. coin, ceramic, jewellery"
      },
      "questionFindTime": {
        "question": "Please estimate the dating of your find.",
        "help": "If you cannot find the type you can select 'others' option.",
        "buttonOne": "Continue",
        "label": "Period",
        "placeholder": "e.g. Middle Ages, Stone Age"
      },
      "questionAdditionalMaterials": {
        "question": "Would you like to add additional information related to the find site?",
        "help": "Description of additional information",
        "buttonOne": "Continue"
      },
      "questionAddAnotherFind": {
        "question": "Would you like to report another find?",
        "help": "One report can contain several finds. Find instructions from 'More'.",
        "buttonOne": "Yes, please",
        "buttonTwo": "No, thanks"
      },
      "questionOverview": {
        "buttonOne": "Looks good, please send!"
      },
      "questionReportSent": {
        "question": "Your find report has been sent successfully.",
        "help": "Your find report has been sent. You will get an notification of it soon."
      },
      "questionAddMoreInformation": {
        "question": "Would you like to add some additional information to your find report?",
        "help": "If you accept this, you are going to provide some additional information.",
        "buttonOne": "Yes, please",
        "buttonTwo": "No, thanks"
      }
    },
    "findMaterials": {
      "stone": "Stone",
      "slag": "Slag",
      "glass": "Glass",
      "metal": "Metal",
      "leather": "Leather",
      "wood": "Wood",
      "iron": "Iron",
      "bronze": "Bronze",
      "porcelain": "Ceramic"
    },
    "bottomNavBar": {
      "home": "Home",
      "mine": "MyFinds",
      "nearby": "Nearby",
      "report": "Report",
      "more": "More"
    },
    "helpBar": {
      "saveAs": "Save as draft",
      "delete": "Delete",
      "notifications": {
        "noDataAvailable": "Smart help data is not available yet!",
        "reportDeleted": "The report has been deleted succesfully!",
        "reportSent": "The report has been saved as draft succesfully!"
      },
      "dialog": {
        "header": "Help",
        "closeBtn": "Close"
      }
    },
    "photoRenderer": {
      "infoText": "Tap the icon to take or choose a photo",
      "errorHeader": "Photo too large!",
      "errorText": "The photo exceeds the maximum upload size for this site. Photos cannot exceed 30 MB. Please try again!",
      "confirmationBtn": "OK",
      "dialog": {
        "title": "Add Photo",
        "takePhoto": "Take Photo",
        "selectFromGallery": "Select from gallery",
        "cancel": "Cancel"
      }
    },
    "morePage": {
      "headers": {
        "usefulTools": "Useful tools & Resources",
        "tutorials": "Tutorials",
        "recommendedApps": "Recommended Applications"
      },
      "checkLegality": "Find out the location of protected archaeological heritage sites (where no unauthorized investigation is allowed) in the nearby area.",
      "fhaHowToReport": "Reporting a discovery",
      "fhaCulturalHeritageMaterial": "Protecting the archaeological cultural heritage",
      "photoFrame": "Photo frame for taking find photos"
    },
    "facetDrawer": {
      "facetedSearch": "Faceted Search",
      "searchResults": "Search results",
      "searchCriteria": "Search criteria",
      "emptyBtn": "Empty",
      "facetCriteria": {
        "type": "Object name",
        "material": "Material",
        "period": "Period",
        "municipality": "Municipality",
        "province": "Province"
      }
    },
    "langMenu": {
      "abbreviation": {
        "english": "EN",
        "finnish": "FI",
        "swedish": "SV"
      }
    },
    "smartHelper": {
      "table": "Table",
      "map": "Map",
      "nearbySpecific": "Nearby finds",
      "overall": "All finds"
    },
    "appHomePage": {
      "contentContainer": {
        "recentFinds": "Recent Finds",
        "guides": "Guides and Instructions",
        "applicationTagline": "The number of recieved find reports in FindSampo: x",
        "headerTitle": "The Finnish archaeological finds data and reporting platform",
        "learnMore": "Learn More",
        "name": "FindSampo"
      }
    },
    "answerOptions": {
      "date": "Date",
      "approximateDate": "Approximate Date",
      "additionalMaterials": "Additional information",
      "btnEnterManually": "Enter Manually",
      "dialog": {
        "title": "Input Coordinates",
        "content": "Please input coordinates in decimal form.",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "cancel": "Cancel",
        "insert": "Insert"
      }
    },
    "autocompleter": {
      "noOptions": "No options",
      "loading": "Loading",
      "save": "Save"
    }
  };